import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'cl-animated-ellipsis',
    template: ''
})
export class AnimatedEllipsisComponent implements OnDestroy, OnInit {
    public static $name: string = 'clAnimatedEllipsis';

    private delay: number = 500;

    private current: number = 1;
    private max: number = 3;

    private element: HTMLElement;
    private interval: number;

    constructor(
        private $element: ElementRef
    ) {
        this.element = $element.nativeElement;
    }

    public ngOnDestroy() {
        clearInterval(this.interval);
    }

    public ngOnInit() {
        this.interval = setInterval(() => {
            this.setText();
        }, this.delay) as unknown as number;
    }

    private getNextText() {
        this.preventOverflow();

        let count = this.current++;

        let result: string = '';

        for (let i = 0; i <= count; i++) {
            result += '.';
        }

        return result;
    }

    private preventOverflow() {
        if (this.current === this.max) {
            this.current = 0;
        }
    }

    private setText() {
        this.element.textContent = this.getNextText();
    }
}
